import { cssProps } from '@oracle/oraclejet-cssprops';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { usePress } from '../hooks/UNSAFE_usePress';
import { ViewHideIcon, ViewIcon } from '../UNSAFE_ThemedIcons';

type RevealToogleIconProps = {
  onPress: (event: Event) => void;
  isRevealed?: boolean;
};

// TODO: This was copied from ClearIcon. When we have a preact <Button> component we
// will need to refactor to use that.
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-height) once it is available
const ojButtonHeight = '2.75rem';
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-border-radius) once it is available
const ojButtonBorderRadius = 'var(--oj-c-PRIVATE-DO-NOT-USE-core-border-radius-md)';
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-borderless-chrome-text-color) once it is available
const ojButtonBorderlessChromeTextColor = 'var(--oj-c-PRIVATE-DO-NOT-USE-core-text-color-primary)';
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-borderless-chrome-text-color-hover) once it is available
const ojButtonBorderlessChromeTextColorHover =
  'var(--oj-c-PRIVATE-DO-NOT-USE-core-text-color-primary)';
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-borderless-chrome-bg-color-hover) once it is available
const ojButtonBorderlessChromeBgColorHover = 'var(--oj-c-PRIVATE-DO-NOT-USE-core-bg-color-hover)';
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-borderless-chrome-border-color-hover) once it is available
const ojButtonBorderlessChromeBorderColorHover = 'transparent';
// TODO: replace this with var(--oj-c-PRIVATE-DO-NOT-USE-button-icon-size) once it is available
const ojButtonIconSize = 'var(--oj-c-PRIVATE-DO-NOT-USE-core-icon-size-lg)';

const revealToggleIconStyles = {
  base: cssProps`${{
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'var(--oj-c-PRIVATE-DO-NOT-USE-core-cursor-clickable)',

    paddingInline: 0,
    paddingBlock: 0,
    borderRadius: ojButtonBorderRadius,
    color: ojButtonBorderlessChromeTextColor,
    borderColor: 'transparent',
    backgroundColor: 'transparent',

    width: ojButtonHeight,
    height: ojButtonHeight,
    lineHeight: ojButtonHeight,
    fontSize: ojButtonIconSize,

    '&:hover': {
      color: ojButtonBorderlessChromeTextColorHover,
      backgroundColor: ojButtonBorderlessChromeBgColorHover,
      borderColor: ojButtonBorderlessChromeBorderColorHover
    }
  }}`
};

export function RevealToggleIcon({ isRevealed, onPress }: RevealToogleIconProps) {
  const { pressProps } = usePress(onPress);
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  // title attribute. We removed these because title is taking precedence over aria-label and this
  // is messing up the screen readers. To be accessible we are removing title and will implement
  // this as a <Tooltip> component when we have one.
  // TODO JET-51517 implement reveal icon title as a Tooltip
  // const hidePasswordStr = translations.inputPassword_hide();
  // const showPasswordStr = translations.inputPassword_show();
  const passwordMaskedStr = translations.inputPassword_hidden();
  // TODO: Use toggle <Button> when that is available, JET-49207
  return (
    <button
      aria-label={passwordMaskedStr}
      role="switch"
      aria-checked={isRevealed ? false : true}
      class={revealToggleIconStyles.base}
      tabIndex={0}
      {...pressProps}>
      {isRevealed ? <ViewHideIcon /> : <ViewIcon />}
    </button>
  );
}
